import axios from 'axios'

const editPrivacyPolicy = async (data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}systemUsers/updatePrivacyPolicy`,
      data,
      {
        withCredentials: true,
      }
    )
    return response.data
  } catch (error) {
    throw error
  }
}

export default editPrivacyPolicy
